import IBaseillustMaster from "../../interfaces/masters/baseillust-master-interface";

export const baseillustMasterRecords: IBaseillustMaster[] = [
  {
    id: 1,
    fileName: "japanese-paper_white.jpg",
  },
  {
    id: 2,
    fileName: "japanese-paper_brown.jpg",
  },
  {
    id: 3,
    fileName: "japanese-paper_blue.jpg",
  },
  {
    id: 4,
    fileName: "japanese-paper_red.jpg",
  },
];
